import type { RouteObject } from "react-router-dom";
import AppError from "../app-error";
import TallyAgentPage, { agentLoader } from "./tally/Agent";
import TallyConfigPage, { configLoader } from "./tally/Config";
import SyncQueuePage, { queueLoader } from "./tally/Queue";
import SyncQueueItemPage, { queueDetailLoader } from "./tally/QueueDetail";
import RotateAgentKeyPage from "./tally/RotateKey";
import IntegrationErrorsPage, { integrationErrorsLoader } from "./Errors";
import IntegrationSettingsPage, { integrationSettingsLoader } from "./Settings";

/** Ported feature area: Integrations/Tally. Nested under the root route's children. */
export const integrationsRoutes: RouteObject[] = [
  { path: "integrations/tally", Component: TallyAgentPage, loader: agentLoader, errorElement: <AppError /> },
  { path: "integrations/tally/config", Component: TallyConfigPage, loader: configLoader, errorElement: <AppError /> },
  { path: "integrations/tally/queue", Component: SyncQueuePage, loader: queueLoader, errorElement: <AppError /> },
  { path: "integrations/tally/queue/:itemNumber", Component: SyncQueueItemPage, loader: queueDetailLoader, errorElement: <AppError /> },
  { path: "integrations/tally/rotate-key", Component: RotateAgentKeyPage, errorElement: <AppError /> },
  { path: "integrations/errors", Component: IntegrationErrorsPage, loader: integrationErrorsLoader, errorElement: <AppError /> },
  { path: "integrations/settings", Component: IntegrationSettingsPage, loader: integrationSettingsLoader, errorElement: <AppError /> },
];
